<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div v-on:resizemap="$forceUpdate()">
    <v-layout
      class="ma-0 pa-0 justify-center outline mr-0 white"
      fluid
      row
      id="trade-results-page"
    >
      <v-tabs
        v-model="get_current_selected_tab"
        active-class="active-class"
        background-color="white"
        class="mt-0 pt-0"
        dark
        height="0"
        light
      >
        <!--1P1C Tab-->
        <v-tab
          v-if="view_to_display === '1P1C'"
          v-model="first_tab_selected"
          class="trade-blue ma-0 font-weight-light"
          @change="map_rerender_workarount++"
          @click="set_selectors_state(false)"
        >
          <v-icon class="white--text x-large" left>mdi-file-word-box-outline</v-icon>
          1xproduct-1xcountry\
        </v-tab>

        <!--MP1C Tab-->
        <v-tab
          v-if="view_to_display === 'MP1C'"
          class="trade-blue ma-0 font-weight-light"
          @change="map_rerender_workarount++"
        >
          Multiple-Product-1xcountry
        </v-tab>

        <!--1PMC-->
        <v-tab
          v-if="view_to_display === '1PMC'"
          class="trade-blue ma-0 font-weight-light"
          @change="map_rerender_workarount++"
        >
          1xProduct-Multiple-Country
        </v-tab>

        <!--MPMC-->
        <v-tab
          v-if="view_to_display === 'MPMC'"
          class="trade-blue ma-0 font-weight-light"
          @change="map_rerender_workarount++"
        >
          Multiple-product-Multiple-country
        </v-tab>

        //1P1C Resulsts page
        <v-tab
          v-if="true"
          class="trade-blue font-weight-light"
          @click="set_selectors_state(true)"
        >
          <v-icon class="white--text x-large" left>mdi-file-word-box-outline</v-icon>
          View-Snapshot
        </v-tab>

        //1PMC Resulsts page
        <v-tab
          v-if="true"
          class="trade-blue font-weight-light"
          @click="set_selectors_state(true)"
        >
          <v-icon class="white--text x-large" left>mdi-file-word-box-outline</v-icon>
          View-1PMC Snapshot
        </v-tab>

        //MP1C Resulsts page
        <v-tab
          v-if="true"
          class="trade-blue font-weight-light"
          @click="set_selectors_state(true)"
        >
          <v-icon class="white--text x-large" left>mdi-file-word-box-outline</v-icon>
          View-MP1C Snapshot
        </v-tab>

        //Admin
        <v-tab
          v-if="$store.getters.user_type === 'admin' && $store.state.app.displayAdminPage"
          class="trade-blue font-weight-light hidden-sm-and-down"
          @click="set_selectors_state(false)"
        >
          <v-icon class="white--text x-large" left>mdi-file-word-box-outline</v-icon>
          Admin
        </v-tab>

        <!--        =================        =================-->
        <!--        TABS START HERE-->
        <!--        =================        =================-->

        <!--        1P1C-->
        <v-tab-item
          v-if="view_to_display === '1P1C'"
          class="ma-0 pa-0"
          reverse-transition="fade-transition"
          transition="fade-transition"
        >
          <tab1p1c :map_rerender_workarount="map_rerender_workarount" />
        </v-tab-item>

        <!--        MP1C-->
        <v-tab-item v-if="view_to_display === 'MP1C'">
          <tabmp1c
            :cube="cube"
            :cube_-c_-region="cube_C_Region"
            :cube_-main_-region="cube_Main_Region"
            :cube_-trade_-block="cube_Trade_Block"
            :cubehs6code="cubehs6code"
            :cubehs4code="cubehs4code"
            :cubehs2code="cubehs2code"
            :cubesection="cubesection"
            :map_rerender_workarount="map_rerender_workarount"
          />
        </v-tab-item>
        <!--=========================================================================================================-->

        <!--        1PMC-->
        <v-tab-item v-if="view_to_display === '1PMC'">
          <tab1pmc
            :cube="cube"
            :cube_-c_-region="cube_C_Region"
            :cube_-main_-region="cube_Main_Region"
            :cube_-trade_-block="cube_Trade_Block"
            :map_rerender_workarount="map_rerender_workarount"
          />
        </v-tab-item>
        <!--=========================================================================================================-->

        <!--        MPMC-->
        <v-tab-item v-if="view_to_display === 'MPMC'" class="ma-0 pa-0">
          <tabmpmc
            :cube="cube"
            :cube_-c_-region="cube_C_Region"
            :cube_-main_-region="cube_Main_Region"
            :cube_-trade_-block="cube_Trade_Block"
            :cubehs6code="cubehs6code"
            :cubehs4code="cubehs4code"
            :cubehs2code="cubehs2code"
            :cubesection="cubesection"
            :map_rerender_workarount="map_rerender_workarount"
          />
        </v-tab-item>
        <!--=========================================================================================================-->

        //results page for 1P1C HTML PAge
        <v-tab-item
          v-show="true"
          class="ma-0 pa-0"
          reverse-transition="fade-transition"
          transition="fade-transition"
        >
          <v-main class="ma-0 pa-0">
            <v-container bg class="ma-0 pa-0" fluid>
              <v-layout
                align-center=""
                class="ma-0 pa-0"
                fill-height=""
                justify-space-around=""
                row
              >
                <v-flex class="pr-5 ma-0 pt-0" sm12>
                  <p_c_snapshot_report :update="updating" class="ml-1 mr-1 pe-1 pa-0" />
                  <!--                  </v-card>-->
                </v-flex>
              </v-layout>
            </v-container>
          </v-main>
        </v-tab-item>
        <!--=========================================================================================================-->

        //results page for 1PMC
        <v-tab-item
          v-if="true"
          class="ma-0 pa-0"
          reverse-transition="fade-transition"
          transition="fade-transition"
        >
          <v-main class="ma-0 pa-0">
            <v-container bg class="ma-0 pa-0" fluid>
              <v-layout
                align-center=""
                class="ma-0 pa-0"
                fill-height=""
                justify-space-around=""
                row
              >
                <v-flex class="pr-5 ma-0 pt-0" sm12>
                  <div>
                    <iframe
                      id="report_html_1pmc"
                      class="pa-0"
                      style="height: 70vh; width: 100%"
                    ></iframe>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-main>
        </v-tab-item>
        <!--=========================================================================================================-->

        //results page for MP1C
        <v-tab-item
          v-if="true"
          class="ma-0 pa-0"
          reverse-transition="fade-transition"
          transition="fade-transition"
        >
          <v-main class="ma-0 pa-0">
            <v-container bg class="ma-0 pa-0" fluid>
              <v-layout
                align-center=""
                class="ma-0 pa-0"
                fill-height=""
                justify-space-around=""
                row
              >
                <v-flex class="pr-5 ma-0 pt-0" sm12>
                  <div>
                    <iframe
                      id="report_html_mp1c"
                      class="pa-0"
                      style="height: 70vh; width: 100%"
                    ></iframe>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-main>
        </v-tab-item>
        <!--=========================================================================================================-->
        // admin page
        <v-tab-item
          v-if="$store.getters.user_type === 'admin' && $store.state.app.displayAdminPage"
        >
          <v-card flat outlined tile>
            <v-card-text
              class="justify-space-around ma-5 pa-5 align-center overflow-y-auto"
            >
              <p>
                {{ user.fields.include_cell_phone_in_report }}
              </p>
              <p>
                {{
                  $store.state.tradeDSM.dsm_filter_setttings.Product_Combinations.results
                    .trade_value
                }}
              </p>
              <h3 class="bg-">DSM Result</h3>
              <p class="caption">
                {{ $store.state.tradeDSM.dsm_filter_setttings.results.dsmresult }}
              </p>
              <h3>Top 6 Results</h3>
              <p class="caption">
                {{ $store.state.tradeDSM.dsm_filter_setttings.results.top6 }}
              </p>
              <h3>History imports/exp per code and target market</h3>
              <p class="caption">
                {{ $store.state.tradeDSM.dsm_filter_setttings.results.hist_impexp_tm }}
              </p>
              <h3>History imports/exp per code</h3>
              <p class="caption">
                {{ $store.state.tradeDSM.dsm_filter_setttings.results.hist_impexp_total }}
              </p>
              <p>prod search {{ $store.getters.get_product_search_term }}</p>
              <p>marked searcg {{ $store.getters.get_market_search_term }}</p>

              <p>country {{ $store.getters.dsmFilterSettings['Destination_Country'] }}</p>
              <p>product {{ $store.getters.dsmFilterSettings['HS6_Code'] }}</p>
              <p>
                {{ $store.getters.countriesSelectorList }}
              </p>
              <p>
                {{
                  $store.state.user.userServerInfo.user.fields.institution[0].fields
                    .institution_name
                }}
              </p>
              <h3>View type</h3>
              <p>{{ $store.state.tradeDSM.dsm_filter_setttings.Product_Combinations }}</p>

              <h3>User Info-</h3>

              <p>
                {{ $store.state.user.userServerInfo['exchange_rate'] }}
              </p>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-layout>

    <!--TABS-->
  </div>
</template>

<script>
import progressMessageMixin from '@/components/trade-dsm-application/mixins/progress-message';
import {mapGetters, mapMutations} from 'vuex';
import p_c_snapshot_report from '@/components/trade-dsm-application/result-components/snapshot-report-1p1c';
import get_combinations_trade_value from '@/components/trade-dsm-application/mixins/filter-helpers';
// import swal from 'sweetalert';
import Tab1p1c from '@/components/trade-dsm-application/results-pages/tabs/tab-1p1c';
import Tabmp1c from '@/components/trade-dsm-application/results-pages/tabs/tab-mp1c';
import Tab1pmc from '@/components/trade-dsm-application/results-pages/tabs/tab-1pmc';
import Tabmpmc from '@/components/trade-dsm-application/results-pages/tabs/tab-mpmc';

import swal from 'sweetalert';
import _ from 'lodash';
import {crm_action_window} from '@/components/trade-crm-app/js/crm_url_parameters';

export default {
  name: 'tradeResultsPage',
  mixins: [progressMessageMixin, get_combinations_trade_value],
  components: {
    Tabmpmc,
    Tab1pmc,
    Tabmp1c,
    Tab1p1c,
    p_c_snapshot_report,
  },

  data: () => ({
    current_tab_selected: 0,
    first_tab_selected: true,
    products_show: false,
    dsm_result: {},
    busyWithQuery: false,
    loadingTop6: false,
    searchDone: false,
    reportLoading: false,
    map_rerender_workarount: 1,
    word_doc_preparing: false,
    html_doc_preparing: false,
    word_doc_downloaded: false,
    word_doc_emailing: false,
    word_doc_emailing_success: false,
    g1: true,
    g2: true,
    g3: true,
    g4: true,
    snapshot_report_selected: false,
    report_generation_done: false,
  }), //data,

  mounted: function() {
    // document.title = "DSM - RSA";
    window.addEventListener('resize', () => {
      this.map_rerender_workarount++;
    });

    //disable back button
    //https://www.codexworld.com/how-to/disable-browser-back-button-using-javascript/
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function() {
      window.history.go(1);
      swal('The backbutton is not active in this application.', {
        buttons: false,
        timer: 2000,
      });
    };

    this.$store.state.tradeData.report_selections = _.union(
      this.$store.state.tradeData.report_selections,

      JSON.parse(
        this.$store.state.user.userServerInfo.user.fields.institution[0].fields
          .trade_data_reports,
      ),
    );

    this.update_mpmc_graphs();
    console.log(crm_action_window);
    // this.update_mpmc_graphs().then(() => {
    //   crm_action_window();
    // });
  },
  computed: {
    ...mapGetters(['countriesSelectorList', 'productsList']),

    report_to_run: function() {
      const C_Code_length = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .selections.markets.C_Code.length;

      const HS6_Code_length = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .selections.products.HS6_Code.length;
      // 1PC1C
      if (
        (this.view_to_display === '1P1C') & (HS6_Code_length === 1) &&
        C_Code_length === 1 &&
        !this.$store.state.tradeDSM.productsOpen && //do not auto run report if filter boxes are open
        !this.$store.state.tradeDSM.countriesOpen //do not auto run report if filter boxes are open
      ) {
        return '1P1C_Report';
      } else {
        return 'No report';
      }
    },

    view_to_display: function() {
      // return the report type 1P1C, 1pMC etc.

      //        ---------------------------------------------------------
      //        | HS6_Code_length|  C_Code_length | View    |
      //        -----------------------------------------------
      //   1    |   0            |     0          |   MPMC  |
      //   2    |   >1           |     0          |   MPMC  |
      //   3    |   0            |     >1         |   MPMC  |
      //   4    |   >1           |     >1         |   MPMC  |
      //        ---------------------------------------------
      //   5    |   1            |     0          |   1P1C  |
      //   6    |   0            |     1          |   1P1C  |
      //   7    |   1            |     1          |   1P1C  |
      //        ----------------------------------| ----------
      //   8    |   1            |     0          |   1PMC  |
      //   9    |   1            |     >1         |   1PMC  |
      //        ---------------------------------------------
      //  10    |   0            |     1          |   MP1C  |
      //  11    |   >1           |     1          |   MP1C  |
      //        ---------------------------------------------

      // const C_Code_length = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
      //     .selections.markets.C_Code.length;

      const C_Code_length = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .combinations.markets_count;

      // const HS6_Code_length = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
      //     .selections.products.HS6_Code.length;

      const HS6_Code_length = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .combinations.products_count;

      if (
        HS6_Code_length === 0 &&
        C_Code_length === 0 &&
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products
          .HS6_Code.length === 1 &&
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
          .C_Code.length === 1
      ) {
        return '1P1C';
      }

      if (
        (HS6_Code_length === 0 && C_Code_length === 0) ||
        (HS6_Code_length > 1 && C_Code_length === 0) ||
        (HS6_Code_length === 0 && C_Code_length > 1) ||
        (HS6_Code_length > 1 && C_Code_length > 1)
      ) {
        return 'MPMC';
      } else if (HS6_Code_length === 1 && C_Code_length === 1) {
        return '1P1C';
      } else if (
        (HS6_Code_length === 1 && C_Code_length === 0) ||
        (HS6_Code_length === 1 && C_Code_length > 1)
      ) {
        return '1PMC';
      } else if (
        (HS6_Code_length === 0 && C_Code_length === 1) ||
        (HS6_Code_length > 1 && C_Code_length === 1)
      ) {
        return 'MP1C';
      } else {
        return 'UNDEFINED';
      }
    },

    combintation_count: function() {
      return this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
        .combinations;
    },

    // Countries cubes
    cube() {
      let cube_values = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .query_results.cube;

      let items = [];
      for (let i = 0; i < cube_values.length; i++) {
        let item = cube_values[i];
        item['name'] = item;
        items.push(item);
      }

      return {
        headers: [],
        items: items,
      };
    },

    cube_Main_Region() {
      let cube_values = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .query_results['cube_Main_Region'];

      let items = [];
      for (let i = 0; i < cube_values.length; i++) {
        let item = cube_values[i];
        item['name'] = item;
        items.push(item);
      }
      return {
        headers: [
          {
            text: 'Main-Region',
            value: 'Main_Region',
            class: 'table_header_color',
          },

          {
            text: `World Import Value (${this.multiplerString} ${this.currencyString})`,
            value: 'TW_import_product',
            class: 'table_header_color',
          },

          {
            text:
              'Potential: (' +
              this.totalValueString(
                this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations
                  .results.trade_value,
              ) +
              ')',
            value: 'Avg6Major',
            class: 'table_header_color',
          },
        ],
        items: items,
      };
    },

    cube_C_Region() {
      let cube_values = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .query_results['cube_C_Region'];

      let items = [];
      for (let i = 0; i < cube_values.length; i++) {
        let item = cube_values[i];
        item['name'] = item;
        items.push(item);
      }
      return {
        headers: [
          {
            text: 'Sub-Region',
            value: 'C_Region',
            class: 'table_header_color',
          },
          {
            text: `World Import Value (${this.multiplerString} ${this.currencyString})`,
            value: 'TW_import_product',
            class: 'table_header_color',
          },

          {
            text:
              'Potential: (' +
              this.totalValueString(
                this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations
                  .results.trade_value,
              ) +
              ')',
            value: 'Avg6Major',
            class: 'table_header_color',
          },
        ],
        items: items,
      };
    },

    cube_Trade_Block() {
      let cube_values = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .query_results['cube_Trade_Block'];

      let items = [];
      for (let i = 0; i < cube_values.length; i++) {
        let item = cube_values[i];
        item['name'] = item;
        items.push(item);
      }
      return {
        headers: [
          {
            text: 'Trade Block',
            value: 'Trade_Block',
            class: 'table_header_color',
          },
          {
            text: 'Importers',
            value: 'Nr_Importers',
            class: 'table_header_color',
          },

          {
            text:
              'Potential: (' +
              this.totalValueString(
                this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations
                  .results.trade_value,
              ) +
              ')',
            value: 'Avg6Major',
            class: 'table_header_color',
          },
        ],
        items: items,
      };
    },

    // Products Cube
    cubehs6code() {
      let cube_values = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .query_results.cube_HS6_Code;

      let items = [];
      for (let i = 0; i < cube_values.length; i++) {
        let item = cube_values[i];
        item['name'] = item;
        items.push(item);
      }

      let return_values = {
        headers: [
          {
            text: 'HS6-Code',
            value: 'HS6_Code',
            class: 'table_header_color',
          },
          {
            text: `World Import Value (${this.multiplerString} ${this.currencyString})`,
            value: 'TW_import_product',
            class: 'table_header_color',
          },

          {
            text:
              'Potential: (' +
              this.totalValueString(
                this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations
                  .results.trade_value,
              ) +
              ')',
            value: 'Avg6Major',
            class: 'table_header_color',
          },
        ],
        items: items,
      };

      // if (this.view_to_display === 'MPMC') {
      //   return_values.headers.splice(0, 0, {
      //     text: 'Product',
      //     value: 'HS6_Code',
      //     class: 'table_header_color',
      //   });
      // }

      return return_values;
    },
    cubehs4code() {
      let cube_values = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .query_results.cube_HS4_Code;

      let items = [];
      for (let i = 0; i < cube_values.length; i++) {
        let item = cube_values[i];
        item['name'] = item;
        items.push(item);
      }

      let return_values = {
        headers: [
          {
            text: 'HS4-Code',
            value: 'HS4_Code',
            class: 'table_header_color',
          },
          {
            text: `World Import Value (${this.multiplerString} ${this.currencyString})`,
            value: 'TW_import_product',
            class: 'table_header_color',
          },

          {
            text:
              'Potential: (' +
              this.totalValueString(
                this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations
                  .results.trade_value,
              ) +
              ')',
            value: 'Avg6Major',
            class: 'table_header_color',
          },
        ],
        items: items,
      };

      return return_values;
    },
    cubehs2code() {
      let cube_values = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .query_results.cube_HS2_Code;

      let items = [];
      for (let i = 0; i < cube_values.length; i++) {
        let item = cube_values[i];
        item['name'] = item;
        items.push(item);
      }

      let return_values = {
        headers: [
          {
            text: 'HS2-Code',
            value: 'HS2_Code',
            class: 'table_header_color',
          },
          {
            text: `World Import Value (${this.multiplerString} ${this.currencyString})`,
            value: 'TW_import_product',
            class: 'table_header_color',
          },

          {
            text:
              'Potential: (' +
              this.totalValueString(
                this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations
                  .results.trade_value,
              ) +
              ')',
            value: 'Avg6Major',
            class: 'table_header_color',
          },
        ],
        items: items,
      };

      // if (this.view_to_display === 'MPMC') {
      //   return_values.headers.splice(0, 0, {
      //     text: 'HS2_Code',
      //     value: 'HS2_Code',
      //     class: 'table_header_color',
      //   });
      // }

      return return_values;
    },
    cubesection() {
      let cube_values = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
        .query_results.cube_Section;

      let items = [];
      for (let i = 0; i < cube_values.length; i++) {
        let item = cube_values[i];
        item['name'] = item;
        items.push(item);
      }

      let return_values = {
        headers: [
          {
            text: 'Section',
            value: 'Major_Product_Groups',
            class: 'table_header_color',
          },
          {
            text: `World Import Value (${this.multiplerString} ${this.currencyString})`,
            value: 'TW_import_product',
            class: 'table_header_color',
          },

          {
            text:
              'Potential: (' +
              this.totalValueString(
                this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations
                  .results.trade_value,
              ) +
              ')',
            value: 'Avg6Major',
            class: 'table_header_color',
          },
        ],
        items: items,
      };

      // if (this.view_to_display === 'MPMC') {
      //   return_values.headers.splice(0, 0, {
      //     text: 'Section',
      //     value: 'Major_Product_Groups',
      //     class: 'table_header_color',
      //   });
      // }

      return return_values;
    },

    //end products cube
    ...mapGetters(['getDsmAppState', 'app_data', 'get_current_selected_tab', 'user']),

    template_location() {
      return this.$store.state.user.userServerInfo.user.fields.institution[0].fields
        .template_location;
    },
    updating() {
      return this.g1 & this.g2 & this.g3 & this.g4;
    },

    one_product_one_market_update() {
      if (
        this.$store.getters.dsmFilterSettings['HS6_Code'] &&
        this.$store.getters.dsmFilterSettings['Destination_Country']
      ) {
        return Date.now();
      } else {
        return '';
      }
    },
  },
  watch: {
    advanved_filter_in_progress(new_val) {
      if (
        this.combintation_count < 500 &&
        this.combintation_count > 0 &&
        new_val === true &&
        this.view_to_display === 'MPMC'
      ) {
        // this.run_dsm_advanced_query_update_filters();
        this.run_dsm_advanced_query_update_filters();
      }
    },

    view_to_display(new_value) {
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.report_type_to_generate = new_value;
    },

    updating(oldvalue, newvalue) {
      this.$store.commit('setLoadingIndicator', newvalue);
    },

    async one_product_one_market_update(oldvalue, newvalue) {
      console.log('1P1C automatic loading triggered ..', newvalue);
      if (this.one_product_one_market_update) {
        await this.get_1p1c_front_end_data();
      }
    },
    get_current_selected_tab() {
      this.map_rerender_workarount++;
    },
  },
  methods: {
    ...mapMutations(['set_selectors_state']),

    pad(n) {
      return n < 10 ? '0' + n : n;
    },
  },
};
</script>

<style lang="sass" scoped>
.full_height
  height: 100% !important

.temp-outline
  outline: lightgrey solid 1px
  margin: 2px
  padding: 0

.active-class
  background-color: #004d40
  color: white

.iframe
  width: 100%
  height: 70vh
  border-width: 0

  .table_cell
    text-align: right
      background: rebeccapurple
</style>
